export default __webpack_public_path__ + "static/media/fasad14.2a35885c.jpeg";